import {
  CountryCode,
  LanguageCode,
  Locale,
} from 'typescript/constants/localization';

/**
 * This file is a migration / refactor of the original locales.js file.
 * app/javascript/utilities/locales.js
 * not EVERYTHING is migrated, only the parts that are used in the checkout_v3 app
 * migrate the rest of the file as needed.
 */

const SHOP_HARDWARE_PREFIX = '/shop/hardware';

/**
 * shop URLs will look like /shop/hardware/us/en/checkout/v3
 * @returns string - the locale path from the window location
 */
export const getLocaleFromPathname = (): string => {
  const pathname = window.location.pathname.replace(SHOP_HARDWARE_PREFIX, '');
  return pathname.slice(0, 6);
};

/**
 * @returns LanguageCode - the language code from the locale path
 * e.g. /shop/hardware/us/en/checkout/v3 -> en
 */
export const getLanguageCode = (): LanguageCode =>
  getLocaleFromPathname().split('/')[2] as LanguageCode;

/**
 * @returns CountryCode - the country code from the locale path
 * e.g. /shop/hardware/us/en/checkout/v3 -> US
 */
export const getCountryCode = (): CountryCode =>
  getLocaleFromPathname().split('/')[1].toUpperCase() as CountryCode;

/**
 * @returns the locale string from the locale path
 * e.g. /shop/hardware/us/en/checkout/v3 -> en-US
 */
export const getLocaleString = (): Locale => {
  const countryCode = getCountryCode();
  const languageCode = getLanguageCode();

  return `${languageCode}-${countryCode}` as Locale;
};

/**
 * @returns the locale string from the locale path but for internal usage since
 * we have a special case for Japanese language when we are using this with i18next and contentful
 * e.g. /shop/hardware/us/en/checkout/v3 -> en-US
 * e.g. /shop/hardware/jp/ja/checkout/v3 -> ja
 */
export const getLocaleStringInternal = (): string | Locale => {
  const countryCode = getCountryCode();
  const languageCode = getLanguageCode();

  return languageCode === 'ja' ? 'ja' : `${languageCode}-${countryCode}`;
};
